import React, { ReactNode } from "react";

import { css } from "@emotion/react";

import { SwarovskiButton } from "../_shared-components/ui-elements/SwarovskiButton";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { CSS_MQ } from "../../styles/breakpoints";

import cn from "classnames";
import { WrapperComponent } from "../_shared-components/arrangement/WrapperComponent";
import { QuotationType } from "@swo/storefront";
import { FONTS } from "../../styles/fonts";
import { getComponentCMSClassname } from "../cms/edit-overlay/component-hook-class";
import { EXPERIMENTAL_TextWithProductNameRenderer } from "../../domain/swarovski-optik/products/product-name/product-name-renderer";

export function QuotationFamilyPageComponent(props: QuotationType) {
  const cssThemeClassName = `theme-${props.backgroundColor}`;
  const width: "content" | "content-but-full-on-small" =
    props.backgroundColor === "white" ? "content" : "content-but-full-on-small";

  return (
    <WrapperComponent width={width}>
      <div
        className={cn(cssThemeClassName, getComponentCMSClassname(props?.sys?.id))}
        css={css`
          &.theme-white {
            color: ${CSS_COLORS.Green};
            background-color: ${CSS_COLORS.White};
          }

          &.theme-light-green {
            color: ${CSS_COLORS.GreenDark};
            background-color: ${CSS_COLORS.GreenWhite};
          }

          &.theme-dark-green {
            color: ${CSS_COLORS.White};
            background-color: ${CSS_COLORS.GreenDark};
          }
        `}
      >
        <div
          css={css`
            .theme-light-green &,
            .theme-dark-green & {
              padding: 20px 16px;
              ${CSS_MQ.atLeastMd} {
                padding: 40px 30px;
              }
            }

            width: 100%;
            ${CSS_MQ.atLeastMd} {
              width: 30em;
            }

            max-width: 100%;

            margin-left: auto;
            margin-right: auto;

            text-align: center;

            font-size: 24px;
            letter-spacing: 0.8px;
            line-height: 24.78px;

            ${CSS_MQ.atLeastLg} {
              font-size: 30px;
              letter-spacing: 1px;
              line-height: 32px;
            }

            ${CSS_MQ.atLeastXl} {
              font-size: 40px;
              letter-spacing: 1.71px;
              line-height: 42px;
            }
          `}
        >
          <p
            className="u-uppercase u-text-balance u-block"
            css={[
              FONTS.MinervaModernItalic500,
              css`
                color: inherit;
              `,
            ]}
          >
            {props.text}
          </p>

          {props.author && (
            <span
              css={css`
                margin-top: 20px;

                ${FONTS.SwarovskiFutura500};
                color: inherit;

                font-size: 16px;
                letter-spacing: 0.8px;

                ${CSS_MQ.atLeastMd} {
                  font-size: 21px;
                  letter-spacing: 1px;
                }

                text-transform: uppercase;
                display: block;

                &:before {
                  content: "– ";
                }
              `}
            >
              <EXPERIMENTAL_TextWithProductNameRenderer text={props.author} />
            </span>
          )}

          {props.callToAction && (
            <span
              css={css`
                margin-top: 20px;
                display: block;
                color: inherit;
              `}
            >
              <SwarovskiButton
                as={"a"}
                link={props.callToAction.data}
                isInternal={props.callToAction.type === "Internal Link"}
                variant={"outline-inherit"}
                target={props.callToAction.openInNewTab ? "_blank" : undefined}
              >
                {props.callToAction.label}
              </SwarovskiButton>
            </span>
          )}
        </div>
      </div>
    </WrapperComponent>
  );
}
